import * as React from 'react';
import styles from './index.less';
import img_1 from './1.png';
import img_2 from './2.png';
import img_3 from './3.png';
import img_4 from './4.png';
import img_5 from './5.png';
import img_6 from './6.png';
import img_7 from './7.png';
import { AnnounceCard } from '../../SpringFestival2025';
import { FUtil } from '@freelog/tools-lib';

interface AnnounceContentProps {}

function AnnounceContent({}: AnnounceContentProps) {
  const [$isProdEnv] = FUtil.Hook.useGetState<boolean>(
    self.location.hostname.endsWith('.freelog.cn'),
  );

  return (
    <div className={styles.announceModalBody}>
      <div style={{ height: 74 }} />
      <img src={img_1} alt='' />

      <div style={{ height: 20 }} />
      <div className={styles.cards}>
        <AnnounceCard
          resourceID={$isProdEnv ? '68b5e4bb991fb4002fe04032' : '67764c36529799002f8f8e57'}
        />
      </div>
      <div style={{ height: 30 }} />

      <img src={img_2} alt='' />

      <div style={{ height: 20 }} />
      <div className={styles.cards}>
        <AnnounceCard
          resourceID={$isProdEnv ? '68e5e07c2e135f002f38a63c' : '67764c36529799002f8f8e57'}
        />
        <AnnounceCard
          resourceID={$isProdEnv ? '689aed06991fb4002fdf6905' : '67764c36529799002f8f8e57'}
        />
        <AnnounceCard
          resourceID={$isProdEnv ? '68cbd5392e135f002f380057' : '67764c36529799002f8f8e57'}
        />
      </div>
      <div style={{ height: 30 }} />

      <img src={img_3} alt='' />
      <div className={styles.cards}>
        <AnnounceCard
          resourceID={$isProdEnv ? '68c1533a991fb4002fe0c475' : '67764c36529799002f8f8e57'}
        />
        <AnnounceCard
          resourceID={$isProdEnv ? '689eb2bc991fb4002fdf8066' : '67764c36529799002f8f8e57'}
        />
        <AnnounceCard
          resourceID={$isProdEnv ? '68d639ef2e135f002f386378' : '67764c36529799002f8f8e57'}
        />
        <AnnounceCard
          resourceID={$isProdEnv ? '68bfccd7991fb4002fe08ecd' : '67764c36529799002f8f8e57'}
        />
        <AnnounceCard
          resourceID={$isProdEnv ? '68c3b4242e135f002f37b471' : '67764c36529799002f8f8e57'}
        />
        <AnnounceCard
          resourceID={$isProdEnv ? '68cfabc82e135f002f38264c' : '67764c36529799002f8f8e57'}
        />
      </div>
      <div style={{ height: 70 }} />
      <img src={img_4} alt='' />
      <div style={{ height: 20 }} />
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: 80 }}>
        <div className={styles.username}>YET</div>
        <div className={styles.username}>huyigua</div>
        <div className={styles.username}>ADiii</div>
      </div>
      <div style={{ height: 90 }} />
      <img src={img_5} alt='' />
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: 80 }}>
        <div className={styles.username}>Eeyore</div>
        <div className={styles.username}>SSSR</div>
      </div>
      <div style={{ height: 30 }} />
      <img src={img_6} alt='' />
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: 80 }}>
        <div className={styles.username}>pfjfl</div>
      </div>
      <div style={{ height: 30 }} />
      <img src={img_7} alt='' />
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: 80 }}>
        <div className={styles.username}>yueyueyue</div>
        <div className={styles.username}>huyigua</div>
        <div className={styles.username}>pfjfl</div>
        <div className={styles.username}>YC-1123</div>
      </div>
      <div style={{ height: 90 }} />
      <div
        style={{
          fontSize: 12,
          color: '#999',
          lineHeight: '18px',
          textAlign: 'center',
        }}
      >
        <div>
          奖励将在结果公示期结束后，即在官方公布最终获奖名单后的15个工作日内，发放至获奖用户的Freelog账号名下
        </div>
      </div>
      <div style={{ height: 100 }} />
    </div>
  );
}

export default AnnounceContent;
